
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateExternalSupplierDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    street: new FormControl<string | undefined>(undefined, [Validators.maxLength(255)]),
    postCode: new FormControl<string | undefined>(undefined, [Validators.maxLength(20)]),
    city: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    countryId: new FormControl<string | undefined>('', [Validators.maxLength(2), Validators.minLength(2)]),
    iban: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    contactId: new FormControl<number | undefined>(undefined),
})
;
}
      